import { AugmentationPanelLegacyForm } from "@pathwright/ux/src/components/augmentation/AugmentationPanelLegacyForm"
import NotificationsDigestSettings from "../NotificationsDigestSettings"

function NotificationDigestSettingsAugmentation() {
  return (
    <AugmentationPanelLegacyForm cardFieldPadding>
      <NotificationsDigestSettings />
    </AugmentationPanelLegacyForm>
  )
}

export default NotificationDigestSettingsAugmentation
